module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external "projection-grid-core"
// module id = 16
// module chunks = 0